import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { DOMAIN, BRAND } from '../constants';
import { Reveal, SectionHero } from '../components/UI';

export const Realizations: React.FC = () => {
  const [filter, setFilter] = useState("Tous");
  const categories = ["Tous", "Balcons", "Escaliers", "Solage", "Planchers radiants", "Plates-bandes", "Coulis de béton"];
  const projects = [
    { id: 1, img: "https://betonmobiledescantons.com/img/balcon1.jpg", title: "Balcon de Façade", category: "Balcons" },
    { id: 2, img: "https://betonmobiledescantons.com/img/balcon2.jpg", title: "Balcon Arrière", category: "Balcons" },
    { id: 3, img: "https://betonmobiledescantons.com/img/escalier1.jpg", title: "Escalier Entrée", category: "Escaliers" },
    { id: 4, img: "https://betonmobiledescantons.com/img/salage1.jpg", title: "Solage Résidentiel", category: "Solage" },
    { id: 5, img: "https://betonmobiledescantons.com/img/plancher1.jpg", title: "Plancher Radiant", category: "Planchers radiants" },
    { id: 6, img: "https://betonmobiledescantons.com/img/plate1.jpg", title: "Aménagement Paysager", category: "Plates-bandes" }
  ];
  const filteredProjects = filter === "Tous" ? projects : projects.filter(p => p.category === filter);

  const pageTitle = "Nos Réalisations de Béton & Planchers Chauffants | Portfolio Granby";
  const pageDesc = "Découvrez nos projets : balcons, escaliers, solages, planchers radiants et aménagements paysagers en béton. Qualité durable.";
  const canonicalUrl = `${DOMAIN}/realisations`;
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ImageGallery",
    "name": "Réalisations Béton Mobile des Cantons",
    "provider": { "@type": "LocalBusiness", "name": BRAND },
    "images": projects.map(p => ({
      "@type": "ImageObject",
      "name": p.title,
      "caption": p.category,
      "contentUrl": p.img
    }))
  };

  return (
    <div className="bg-slate-50">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDesc} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDesc} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2089&auto=format&fit=crop" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDesc} />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2089&auto=format&fit=crop" />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <SectionHero title="Portfolio" subtitle="Réalisations" image="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2089&auto=format&fit=crop" />
      <div className="container mx-auto px-6 py-20">
        <Reveal>
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-display font-bold text-slate-900 mb-6 uppercase">Nos Réalisations</h2>
            <p className="text-slate-600 text-lg leading-relaxed">Quelques réalisations que nous avons effectuées – Solage, planchers chauffants, balcons, escaliers, plates-bandes, coulis de béton, planchers radiants électriques.</p>
          </div>
        </Reveal>
        <div className="flex flex-wrap gap-2 mb-12 border-b border-slate-200 pb-8 justify-center">
          <span className="py-2 px-4 font-mono text-xs uppercase font-bold text-slate-400 flex items-center">Filtres :</span>
          {categories.map((cat, i) => (
            <button key={i} onClick={() => setFilter(cat)} className={`px-5 py-2 border border-slate-200 font-bold uppercase text-xs tracking-wider transition-all duration-200 ${filter === cat ? 'bg-brand-red text-white border-brand-red' : 'bg-white text-slate-600 hover:bg-brand-red hover:text-white hover:border-brand-red'}`}>{cat}</button>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project, i) => (
            <Reveal key={project.id} delay={i * 50}>
              <div className="group relative overflow-hidden bg-slate-900 aspect-[4/3] cursor-pointer border-b-4 border-brand-red">
                <img src={project.img} alt={project.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity"></div>
                <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-slate-900 to-transparent translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-brand-red font-mono text-xs uppercase mb-1">{project.category}</p>
                  <h3 className="text-white font-display font-bold text-xl uppercase">{project.title}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};